import { Loader } from "../components/Loader";

// RESOLVED: design the whole screen

export const SplashScreen = () => {
    return (
        <Loader height={"100vh"} />
    );
}